import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-error-state',
    templateUrl: './error-state.component.html',
    styleUrls: ['./error-state.component.scss']
})
export class ErrorStateComponent {

    @Output() handleRetakeImageEmitter = new EventEmitter();
    @Output() handleEnterManualEmitter = new EventEmitter();

    handleRetakeImage() {
        this.handleRetakeImageEmitter.emit();
    }

    handleEnterManualDetails() {
        this.handleEnterManualEmitter.emit();
    }

}
